import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { fadeIn } from '../variants';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const Artist = () => {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArtists();
  }, []);

  const loadArtists = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'artists'));
      const artistsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setArtists(artistsData);
    } catch (error) {
      console.error('Error loading artists:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 bg-[#f9f9f9]">
        <div className="container mx-auto text-center">
          <p>Loading artists...</p>
        </div>
      </section>
    );
  }

  if (artists.length === 0) {
    return (
      <section className="py-16 bg-[#f9f9f9]">
        <div className="container mx-auto text-center">
          <h2 className="h2 max-w-[370px] mx-auto mb-8">Our Artists:</h2>
          <p>No artists available at this time.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-[#f9f9f9]">
      <div className="container mx-auto text-center">
        <motion.h2
          variants={fadeIn('up')}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.6 }}
          className="h2 max-w-[370px] mx-auto lg:mb-20"
        >
          Our {artists.length > 1 ? 'Artists' : 'Artist'}:
        </motion.h2>
        <div className="flex flex-col lg:flex-row gap-12 justify-center items-center">
          {artists.map((artist) => (
            <div key={artist.id} className="text-center">
              <Link to={{ pathname: '/gallery', state: { artist: artist.name } }}>
                {artist.image ? (
                  <img 
                    src={artist.image} 
                    alt={artist.name} 
                    className="w-[400px] h-[300px] object-cover mb-4 cursor-pointer" 
                  />
                ) : (
                  <div className="w-[400px] h-[300px] bg-gray-200 flex items-center justify-center mb-4 cursor-pointer">
                    <span className="text-gray-400">No Image</span>
                  </div>
                )}
              </Link>
              <h3 className="text-xl font-medium mt-4">{artist.name}</h3>
              {artist.instagramUrl && artist.instagram && (
                <a 
                  href={artist.instagramUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-600 hover:underline block mt-2"
                >
                  {artist.instagram}
                </a>
              )}
              {artist.email && (
                <p className="text-sm text-gray-600 mt-2">{artist.email}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Artist;